<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <input-text :modelName="modelName" :storeName="storeName" :mutationName="mutationName" :disabled="disabled" />
  </div>
</template>
<script>
import inputText from './input/input-text.vue'
export default {
  components: { inputText },
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
  ],
  created() {
  },
}
</script>
